import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import {
  ChatIcon,
  EngagingIcon,
  MonitorIcon,
  PlugIcon,
  ToolIcon,
  UserIcon,
} from '@segment/matcha/components/Icons/Brandbook'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import type { PageConfig } from '@segment/contexts/page'
import { usePageConfig } from '@segment/contexts/page'

const getCards = (config: PageConfig) => [
  {
    key: `general-support`,
    heading: `General Support`,
    description: `Browse our resources, search the knowledge base, or submit a ticket to our support team.`,
    icon: ToolIcon,
    href: `/help/`,
  },
  {
    key: `suggest-integration`,
    heading: `Suggest an integration`,
    description: `Suggest a new source or destination to be added to Segment.`,
    icon: PlugIcon,
    href: `${config.appUrl}/goto-my-workspace/destinations/catalog/?category=Requests`,
  },
  {
    key: `contact-sales`,
    heading: `Contact Sales`,
    description: `Ask about our Business tier products, pricing, or request a demo.`,
    icon: ChatIcon,
    href: `/demo/`,
  },
  {
    key: `website-issue`,
    heading: `Technical support`,
    description: `Can't find your answer elsewhere? Submit a ticket with our Technical Support team.`,
    icon: MonitorIcon,
    href: `${config.appUrl}/workspaces/?contact=1`,
  },
  {
    key: `partner-program`,
    heading: `Partner Program`,
    description: `Access sales support, technical training, and co-marketing opportunities.`,
    icon: EngagingIcon,
    href: `/partners/`,
  },
  {
    key: `billing-and-account`,
    heading: `Billing and account`,
    description: `Ask about billing, pricing, or account and workspace concerns.`,
    icon: UserIcon,
    href: `/contact/billing/`,
  },
]

const Cards = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 2, lg: 3 }}>
          {getCards(pageConfig).map(({ heading, description, href, key, icon: Icon }) => (
            <CardBase key={key} href={getAbsoluteUrl(href, pageConfig)}>
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <IconWrapper>
                      <Icon />
                    </IconWrapper>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline tag="h2">{heading}</Card.Headline>
                  <Card.Description>{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="right">
                  <ChevronRightIcon />
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </ColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const IconWrapper = styled.div`
  svg {
    width: 36px;
    height: 36px;
  }
`

export default Cards
